const routes = [
    {
        path: 'weaver',
        title: 'Weaver - daily word ladder game | Weaver Games',
        desc: 'Transform one word into another, one letter at a time. A new puzzle is hand-woven every day.',
        ogTitle: 'Weaver - daily word ladder game',
        ogDesc: 'Play today\'s Weaver on Weaver Games.',
        twitterTitle: 'Weaver - daily word ladder game',
        twitterDesc: 'Play today\'s Weaver on Weaver Games.',
        url: 'https://wordwormdormdork.com/weaver/',
        image: '/images/og/weaver-og.png',
        appleTouchIcon: '/images/icons/weaver-icon.png',
        structuredData: {
            type: 'VideoGame',
            name: 'Weaver',
            genre: 'Word ladder puzzle'
        }
    },
    {
        path: 'weaver-x',
        title: 'Weaver X - daily word ladder game, with a twist | Weaver Games',
        desc: 'Transform one word into another, one letter at a time. A new puzzle is hand-woven every day.',
        ogTitle: 'Weaver X - daily word ladder game, with a twist',
        ogDesc: 'Play today\'s Weaver X on Weaver Games.',
        twitterTitle: 'Weaver X - daily word ladder game, with a twist',
        twitterDesc: 'Play today\'s Weaver X on Weaver Games.',
        url: 'https://wordwormdormdork.com/weaver-x/',
        image: '/images/og/weaver-x-og.png',
        appleTouchIcon: '/images/icons/weaver-x-icon.png',
        structuredData: {
            type: 'VideoGame',
            name: 'Weaver X',
            genre: 'Word ladder puzzle'
        }
    },
    {
        path: 'subtext',
        title: 'Subtext - How many words can you make? | Weaver Games',
        desc: 'Create as many words as you can. A new puzzle is hand-woven every day.',
        ogTitle: 'Subtext - How many words can you make?',
        ogDesc: 'Play today\'s Subtext on Weaver Games.',
        twitterTitle: 'Subtext - How many words can you make?',
        twitterDesc: 'Play today\'s Subtext on Weaver Games.',
        url: 'https://wordwormdormdork.com/subtext/',
        image: '/images/og/subtext-og.png',
        appleTouchIcon: '/images/icons/subtext-icon.png',
        structuredData: {
            type: 'VideoGame',
            name: 'Subtext',
            genre: 'Word puzzle'
        }
    }
];

function getRouteConfig(path) {
    return routes.find(route => route.path === path) || null;
}

function getRouteConfigByPathname(pathname) {
    // Remove leading slash and get the first segment
    const cleanPath = pathname.replace(/^\//, '').split('/')[0];
    return getRouteConfig(cleanPath);
}

function generateStructuredData(routeConfig) {
    const baseData = {
        "@context": "https://schema.org",
        "author": {
            "@type": "Organization",
            "name": "Weaver Games"
        }
    };

    if (routeConfig?.structuredData) {
        // Game route
        return {
            ...baseData,
            "@type": routeConfig.structuredData.type,
            "name": routeConfig.structuredData.name,
            "url": routeConfig.url,
            "applicationCategory": "Game",
            "operatingSystem": "Web",
            "genre": routeConfig.structuredData.genre
        };
    } else {
        // Homepage
        return {
            ...baseData,
            "@type": "WebSite",
            "name": "Weaver Games",
            "url": "https://wordwormdormdork.com",
            "description": "A collection of daily word games. Play Weaver, Weaver X, and Subtext - three unique word puzzles with new challenges every day."
        };
    }
}

module.exports = {
    routes,
    getRouteConfig,
    getRouteConfigByPathname,
    generateStructuredData
}; 